module.exports = __webpack_public_path__ + "static/media/JSDoc.10e433d0.png";